<!-- <p-toast></p-toast> -->

<div class="bank-details-container">

    <!-- Hidden on Small screens -->
    <!-- Visible on Small screens -->
    <div class="block md:hidden">
        <div *ngIf="loading">
            <div id="pause" class="flex align-items-center justify-content-center">
                <div id="spinner"></div>
            </div>
        </div>
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                    <!-- <mat-icon>menu</mat-icon> -->
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left"></ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                  class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
            </p-toolbar>
            <p-card class="mobile-card"> <div class="mobile_search">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="mobileSearch($any($event.target).value)"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
            </div></p-card>
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobileFarmerPreEstimateSurveyData"
                (click)="selectPreSurveyData(item)">
                <!-- <table cellspacing="1"> -->
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl"><b>{{item.appID}}</b>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DATE_OF_SUBMIT'| translate}}</b></td>
                        <td>
                            {{item.AssignedDate | date:'medium'}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DATE_OF_RESUBMIT'| translate}}</b></td>
                        <td>
                            {{item.LastSubmittedDate | date:'medium'}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'APPLICANT_TYPE'| translate}}</b></td>
                        <td>
                            {{item.ApplicantType}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FARMER_NAME'| translate}}</b></td>
                        <td>
                            {{item.FarmerName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.village}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'BLOCK'| translate}}</b></td>
                        <td>
                            {{item.block}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DISTRICT'| translate}}</b></td>
                        <td>
                            {{item.district}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'AGE_OF_APPLICATION'| translate}}</b></td>
                        <td>
                            {{item.AgeOfApplication}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                        <td>
                            {{item.ProgrammeName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'LAND_DETAIL'| translate}}</b></td>
                        <td>
                            {{item.LandDetail}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'TOTAL_AREA'| translate}}</b></td>
                        <td>
                            {{item.Total_Area}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'APPLICATION_STATUS'| translate}}</b></td>
                        <td>
                            {{item.Status_Ar}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'DEPT_REMARKS'| translate}}</b></td>
                        <td>
                            {{item.DeptRemarks}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'ACT_ON_PREVIOUS_ACTION'| translate}}</b></td>
                        <td>
                            {{item.ActOnPrevAction}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FINANCIAL_YEAR'| translate}}</b></td>
                        <td>
                            {{item.FinYear}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VIEW_APPLICATION' | translate}}</b></td>
                        <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectViewApplication(item,item?.Status_Ar)"></button></td>
                    </tr>
                    <tr>
                        <td><b>{{'ESTIMATION_ACTION'| translate}}</b></td>
                        <td *ngIf="item.PreEstimateStatus==2">
                            <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                class="p-button-rounded p-button-text" (click)="addEstimation(item)"></button>
                        </td>
                        <td *ngIf="item.PreEstimateStatus==1">
                            <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                (click)="updateEstimation(item)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                            <!-- <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                                class="p-button-rounded p-button-text p-button-danger"
                                (click)="deleteEstimation(item)"></button> -->
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div>

    <div class="grid hidden md:block">
        <div class="col-12">
            <div class="card">
                <div class="card dashboardTable">
                    <p-toolbar styleClass="mb-4">
                        <ng-template pTemplate="left">
                            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                                class="p-button-success"></button> -->
                            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                        </ng-template>
                        <ng-template pTemplate="right">
                            <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                            <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                                class="p-button-help"></button>
                            <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                class="p-button-info ml-3"></button>
                            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                        </ng-template>

                    </p-toolbar>
                    <p-table #farmerPreEstimateSurveyTable [value]="farmerPreEstimateSurveyData" dataKey="id"
                        [rows]="10" [paginator]="true" [globalFilterFields]="['appID','registerationDate_filter', 'registerationReassignDate_filter', 'ApplicantType','FarmerName','village','block', 'district','AgeOfApplication','ProgrammeName',
                        'LandDetail','Total_Area', 'Status_Ar', 'DeptRemarks', 'ActOnPrevAction', 'FinYear']" responsiveLayout="scroll"
                        [rowHover]="true" sortMode="multiple" [multiSortMeta]="multiSortMeta"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <h5 class="m-0">{{'PRE_ESTIMATE_SURVEY'| translate}}</h5>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="farmerPreEstimateSurveyTable.filterGlobal($any($event.target).value, 'contains')"
                                        placeholder="{{'SEARCH'| translate}}" />
                                </span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="appID">{{'APP_ID'| translate}}
                                    <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                                    <p-sortIcon field="appID"></p-sortIcon>
                                </th>
                                <th pSortableColumn="AssignedDate">{{'DATE_OF_SUBMIT'| translate}}
                                    <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AssignedDate"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LastSubmittedDate">{{'DATE_OF_RESUBMIT'| translate}}
                                    <p-columnFilter type="text" field="registerationReassignDate_filter" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LastSubmittedDate"> </p-sortIcon>
                                </th>
                                <th pSortableColumn="ApplicantType">{{'APPLICANT_TYPE'| translate}}
                                    <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ApplicantType"></p-sortIcon>
                                </th>
                                <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                                    <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="FarmerName"></p-sortIcon>
                                </th>
                                <th pSortableColumn="village">{{'VILLAGE'| translate}}
                                    <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                                    <p-sortIcon field="village"></p-sortIcon>
                                </th>
                                <th pSortableColumn="block">{{'BLOCK'| translate}}
                                    <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                                    <p-sortIcon field="block"></p-sortIcon>
                                </th>
                                <th pSortableColumn="district">{{'DISTRICT'| translate}}
                                    <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                                    <p-sortIcon field="district"></p-sortIcon>
                                </th>
                                <th pSortableColumn="AgeOfApplication">{{'AGE_OF_APPLICATION'| translate}}
                                    <p-columnFilter type="text" field="AgeOfApplication" display="menu">
                                    </p-columnFilter>
                                    <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                                </th>
                                <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                                    <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ProgrammeName"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LandDetail">{{'LAND_DETAIL'| translate}}
                                    <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LandDetail"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                                    <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Total_Area"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
                                    <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Status_Ar"></p-sortIcon>
                                </th>
                                <th pSortableColumn="DeptRemarks">{{'DEPT_REMARKS'| translate}}
                                    <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
                                    <p-sortIcon field="DeptRemarks"></p-sortIcon>
                                </th>
                                <th pSortableColumn="ActOnPrevAction">{{'ACT_ON_PREVIOUS_ACTION'| translate}}
                                    <p-columnFilter type="text" field="ActOnPrevAction" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ActOnPrevAction"></p-sortIcon>
                                </th>
                                <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                                    <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                                    <p-sortIcon field="FinYear"></p-sortIcon>
                                </th>
                                <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>
                                <th pSortableColumn="">{{'ESTIMATION_ACTION'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                                <td>{{product.appID}}</td>
                                <td>{{product.AssignedDate | date:'medium'}}</td>
                                <td>{{product.LastSubmittedDate | date:'medium'}}</td>
                                <td>{{product.ApplicantType}}</td>
                                <td>{{product.FarmerName}}</td>
                                <td>{{product.village}}</td>
                                <td>{{product.block}}</td>
                                <td>{{product.district}}</td>
                                <td>{{product.AgeOfApplication}}</td>
                                <td>{{product.ProgrammeName}}</td>
                                <td>{{product.LandDetail}}</td>
                                <td>{{product.Total_Area}}</td>
                                <td>{{product.Status_Ar}}</td>
                                <td>{{product.DeptRemarks}}</td>
                                <td>{{product.ActOnPrevAction}}</td>
                                <td>{{product.FinYear}}</td>
                                <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                        class="p-button-rounded p-button-accent mr-1 btnSize"
                                        (click)="selectViewApplication(product,product?.Status_Ar)"></button></td>
                                <td>
                                    <button *ngIf="product.PreEstimateStatus==2" pButton pRipple type="button" pTooltip="Add-Estimation"
                                        icon="pi pi-plus" class="p-button-rounded p-button-text" (click)="addEstimation(product)"></button>
                                    <button *ngIf="product.PreEstimateStatus==1" pButton pRipple type="button" pTooltip="Edit-Estimation"
                                        (click)="updateEstimation(product)" icon="pi pi-pencil" class="p-button-rounded p-button-text"></button>
                                    <!-- <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                                                                        class="p-button-rounded p-button-text p-button-danger"
                                                                        (click)="deleteEstimation(product)"></button> -->
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex align-items-center justify-content-between">
                                {{'IN_TOTAL_THERE_ARE'| translate}} {{farmerPreEstimateSurveyData ?
                                farmerPreEstimateSurveyData.length : 0 }} {{'FARMER_PRE_SURVEY_ADDED'| translate}}.
                            </div>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
    <!-- Hidden on small screens -->
</div>


<p-dialog header="" [baseZIndex]="-101" [(visible)]="displayPreEstDialog" [modal]="true" [style]="{width: '85%',height:'100%'}"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()">
    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div class="field md:col-4 col-12">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                    programmeAppId}}</label></label>
        </div>

        <div class="field md:col-4 col-12">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
                    uppercase}}</label></label>
        </div>
        <div class="field md:col-4 col-12">
            <label>{{'PROG_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programName |
                    uppercase}}</label></label>
        </div>
    </div>

    <div class="card field-content" style="margin-bottom: 5px;">
        <form [formGroup]="submitEstimateForm">
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-3">
                    <label>{{'SOIL_TYPE'| translate}}
                    </label>
                    <input pInputText id="soilType" type="text" formControlName="soilType"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.soilType.errors}"
                        placeholder="{{'SOIL_TYPE' | translate}}" />
                    <div *ngIf="(isSubmitted || f.soilType.touched) && f.soilType.errors" class="invalid-feedback">
                        <div *ngIf="f.soilType.errors.required">{{'SOIL_TYPE_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'CROP_TYPE'| translate }}</label>
                    <p-dropdown [options]="cropTypeList" formControlName="cropType"
                        placeholder="{{'SELECT_CROP_TYPE'| translate}}" optionLabel="label" optionValue="data"
                        (ngModelChange)="getCropTypeName($event)">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.cropType.touched) && f.cropType.errors" class="invalid-feedback">
                        <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'CROP'| translate }}</label>
                    <p-dropdown [options]="cropBasedNames" formControlName="cropId"
                        placeholder="{{'SELECT_CROP'| translate}}" optionLabel="label" optionValue="data">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.cropId.touched) && f.cropId.errors" class="invalid-feedback">
                        <div *ngIf="f.cropId.errors.required">{{'CROP_IS_REQ'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'WATER_SOURCE'| translate }}</label>
                    <p-dropdown [options]="waterSourceList" formControlName="waterSource"
                        placeholder="{{'SELECT_WATER_SOURCE_TYPE'| translate}}" optionLabel="waterSource"
                        optionValue="id" [(ngModel)]="selectedWatersourceType">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.waterSource.touched) && f.waterSource.errors" class="invalid-feedback">
                        <div *ngIf="f.waterSource.errors.required">{{'WATER_SOURCE_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'WATER_PRESSURE'| translate}}</label>
                    <input pInputText id="waterPressure" type="text"  formControlName="waterPressure"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.waterPressure.errors}"
                        placeholder="{{'WATER_PRESSURE' | translate}}" />
                    <div *ngIf="(isSubmitted || f.waterPressure.touched) && f.waterPressure.errors" class="invalid-feedback">
                        <div *ngIf="f.waterPressure.errors.required">{{'WATER_PRESSURE_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'WATER_QUALITY'| translate}}</label>
                    <input pInputText id="waterQuality" type="text" formControlName="waterQuality"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.waterQuality.errors}"
                        placeholder="{{'WATER_QUALITY' | translate}}" />
                    <div *ngIf="(isSubmitted || f.waterQuality.touched) && f.waterQuality.errors" class="invalid-feedback">
                        <div *ngIf="f.waterQuality.errors.required">{{'WATER_QUALITY_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'PH'| translate}}</label>
                    <input pInputText id="ph" type="text" formControlName="ph"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.ph.errors}"
                        placeholder="{{'PH' | translate}}" />
                    <div *ngIf="(isSubmitted || f.ph.touched) && f.ph.errors" class="invalid-feedback">
                        <div *ngIf="f.ph.errors.required">{{'PH_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'EC'| translate}}</label>
                    <input pInputText id="ec" type="text" formControlName="ec"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.ec.errors}"
                        placeholder="{{'EC' | translate}}" />
                    <div *ngIf="(isSubmitted || f.ec.touched) && f.ec.errors" class="invalid-feedback">
                        <div *ngIf="f.ec.errors.required">{{'EC_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'WATER_REQ'| translate}}</label>
                    <input pInputText id="waterReq" type="text"  formControlName="waterReq"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.waterReq.errors}"
                        placeholder="{{'WATER_REQ' | translate}}" />
                    <div *ngIf="(isSubmitted || f.waterReq.touched) && f.waterReq.errors" class="invalid-feedback">
                        <div *ngIf="f.waterReq.errors.required">{{'WATER_REQ_IS_REQUIRED'| translate}}
                        </div>
                    </div>
                </div>
                <!-- <div class="field col-12 md:col-3">
                    <label>{{'PLANT_SPACING'| translate}}</label>
                    <input pInputText id="plantSpacing" type="text" formControlName="plantSpacing"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.plantSpacing.errors}"
                        placeholder="{{'PLANT_SPACING'| translate}}" />
                    <div *ngIf="(isSubmitted || f.plantSpacing.touched) && f.plantSpacing.errors" class="invalid-feedback">
                        <div *ngIf="f.plantSpacing.errors.required">{{'PLANT_SPACING_IS_REQUIRED'| translate}}</div>
                        <div *ngIf="f.plantSpacing.errors.min">{{'VALUE_MUST_BE_GREATER_THAN_OR_EQUAL_TO_0.6'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-3">
                    <label>{{'ROW_SPACING'| translate}}</label>
                    <input pInputText id="rowSpacing" type="text" formControlName="rowSpacing"
                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && f.rowSpacing.errors}"
                        placeholder="{{'ROW_SPACING'| translate}}" />
                    <div *ngIf="(isSubmitted || f.rowSpacing.touched) && f.rowSpacing.errors" class="invalid-feedback">
                        <div *ngIf="f.rowSpacing.errors.required">{{'ROW_SPACING_IS_REQUIRED'| translate}}</div>
                        <div *ngIf="f.rowSpacing.errors.min">{{'VALUE_MUST_BE_GREATER_THAN_OR_EQUAL_TO_0.3'| translate}}</div>
                    </div>
                </div> -->
                <div class="field col-12 md:col-3">
                    <label style="margin-right:4px;">{{'SPACING'| translate }}</label>
                    <p-dropdown [options]="rowPlantSpacingData" formControlName="spacing"
                        placeholder="{{'SELECT_SPACING'| translate}}" optionLabel="Spacing" optionValue="Spacing">
                    </p-dropdown>
                    <div *ngIf="(isSubmitted || f.spacing.touched) && f.spacing.errors" class="invalid-feedback">
                        <div *ngIf="f.spacing.errors.required">{{'SPACING_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
            </div>

        </form>
    </div>

    <div class="gps-coordinate-container">
        <div class="card">
            <h5>{{'CAPTURE_GPS_COORDINATES' | translate}}</h5>
            <div *ngIf="geoLocMulArray && geoLocMulArray.length>0 || overlays.length>0" class="dashboardTable">
                <ng-container *ngFor="let array of geoLocMulArray; let i = index">
                    <p-table [value]="array" [rows]="8" showGridlines [tableStyle]="{ 'width': '30%' }"
                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                        <ng-template pTemplate="caption">
                            <p>Table {{ i + 1}}</p>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{'CORNER_ID' | translate}}</th>
                                <th>{{'LATITUDE'| translate}}</th>
                                <th>{{'LONGITUDE'| translate}}</th>
                                <th *ngIf="geoLocMulArray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                            <tr>
                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                <td class="surveyEstimateTable">
                                    <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate(rowIndex, i)"
                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <!-- <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}} {{geolocationsarray ?
                                geolocationsarray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                            </div> -->
                            <button *ngIf="geoLocMulArray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture(i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                class="p-button-info mr-2 mb-2"></button>
                            <button *ngIf="geoLocMulArray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon(i)" label="{{'Delete Polygon' | translate}}"
                                class="p-button-danger mr-2 mb-2"></button>

                            <button *ngIf="geoLocMulArray.length - 1 == i && geoLocMulArray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon(i)" label="{{'Create New Polygon' | translate}}"
                                class="p-button-warning mr-2 mb-2"></button>
                        </ng-template>
                    </p-table>
                </ng-container>
                <!-- <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays"></p-gmap> -->
                <p-gmap *ngIf="mapEnable" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="options"
                    [overlays]="overlays" (onOverlayDragEnd)="onDrag($event)"></p-gmap>

            </div>
            <div class="my-2 proDataButton flex justify-content-center">
                <p class="invalid-feedback" *ngIf="geolocationsarray && geolocationsarray.length<4 && coordinateError">{{coordinateError | translate}}</p>
                <!-- <button pButton pRipple type="submit" (click)="onCapture()" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                    class="p-button-info mr-2 mb-2"></button> -->
                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation()" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                    class="p-button-secondary mr-2 mb-2"></button>
            </div>

        </div>
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-4 col-12">
                <label>{{'SURVEY_AREA'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{surveyArea}}</label></label>
            </div>
            <div *ngIf="landArea > 0" class="field md:col-4 col-12">
                <label>{{'CALCULATED_AREA'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{landArea | number : '1.2-2'}}</label></label>
            </div>
        </div>
        <div *ngIf="landArea > 0 && (landArea - surveyArea > 0.1*landArea || surveyArea - landArea > 0.1*landArea)" class="p-fluid p-formgrid justify-content-center areaError mb-4" style="display: flex; flex-wrap:wrap">
            <p>{{ "CALCULATED_AREA_IS_MUCH_GREATER_THAN_SURVEYED_AREA._PLEASE_RECAPTURE_THE_COORDINATES" | translate }}</p>
        </div>
    </div>




    <div class="card block md:hidden">
        <h5>{{'CAPTURE_IMAGE'| translate}}</h5>
        <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>

            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="word-break: break-word;display: flex;
                                justify-content: space-between">
                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block; width:200px">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)" class="video-align"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>


    <div class="card hidden md:block">
        <!-- <div class="flex justify-content-start my-0 py-0 note-msg">
            <p>NOTE: Capture all GPS Coordinates before Uploading the documents.</p>
        </div> -->
        <div class="flex justify-content-center my-0 py-2 header-img">
            <p>{{'CAPTURE_IMAGE'| translate}}</p>
        </div>
        <div class="flex flex-wrap justify-content-center">
            <div class="m-2">
                <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType" placeholder="{{'CHOOSE_DOCUMENT_TYPE'| translate}}"
                    optionLabel="name" [showClear]="true"></p-dropdown>

            </div>
            <div class="m-2">
                <button (click)="onCaptureImage()" pButton pRipple type="button" label="{{'CAPTURE_IMAGE'| translate}}" [disabled]="!selctedFileType"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
        <div>
            <div>
                <div>
                    <div class="document-list gap-4" style="display: flex; flex-wrap:wrap;">
                        <div class="document p-fluid p-formgrid grid mt-5"
                            *ngFor="let item of documentList; let i=index">
                            <div>
                                <span style="display: flex; justify-content: space-between">
                                    <!-- {{item.displayName}} -->

                                    <p style="margin-bottom: 5px;" *ngIf="item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 5px;" *ngIf="!item.isUploaded" target="_blank">
                                        {{item.name}}
                                    </p>
                                    <i class="pi pi-times cross-icon" (click)="removeImg(i)"></i>
                                </span>
                                <img [src]="item.attachmentRawUrl"
                                    style="max-width: 300px; max-height: 300px; display: block;">
                            </div>
                            <!-- <div class="description">
                                <span>
                                    {{item.displayName}}
                                    <br>
                                    <p style="margin-bottom: 0;" *ngIf="item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                    <p style="margin-bottom: 0;" *ngIf="!item.isUploaded" target="_blank"> {{item.name}}
                                    </p>
                                </span>
                            </div> -->
                        </div>
                        <p class="invalid-feedback" *ngIf="documentList && documentList.length<3">
                            {{imageError}}</p>
                    </div>
                </div>
            </div>
        </div>
        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true" [draggable]="false"
            [style]="{width: '98vw'}" [resizable]="false" (onHide)="onCloseImageDialog()">
            <div *ngIf="displayCameraComponent">
                <div class="camera-container">
                    <div *ngIf="locationError" style="color: red; font-weight: bold;">
                        {{locationError}}
                    </div>
                    <div *ngIf="!imageCaptured">
                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                            [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                            (initError)="handleInitError($event)"></webcam>
                        <br />
                    </div>

                    <h4 *ngIf="errors.length > 0">"{{'MESSAGES'| translate}}":</h4>
                    <ul *ngFor="let error of errors">
                        <li>{{error | json}}</li>
                    </ul>
                </div>
                <div class="webcam-btn" *ngIf="!imageCaptured">
                    <button pButton pRipple type="button" label="{{'CAPTURE'| translate}}" class="p-button-success m-2"
                        (click)="triggerSnapshot()"></button>
                    <button pButton pRipple type="button" label="{{'SWITCH_CAMERA'| translate}}" class="p-button-success m-2"
                        (click)="showNextWebcam(true)"></button>
                </div>
                <div class="snapshot" *ngIf="imageCaptured">
                    <img [src]="webcamImage.imageAsDataUrl" />
                    <div *ngIf="fencingError" style="color: red; font-weight: bold; margin-top:10px;">
                        {{fencingError}}
                    </div>
                </div>
                <div class="webcam-btn" *ngIf="imageCaptured">
                    <button pButton pRipple type="button" label="{{'UPLOAD'| translate}}" class="p-button-success m-2"
                        (click)="uploadPicture()" [disabled]="!isInsideFencing"></button>
                    <button pButton pRipple type="button" label="{{'RETAKE'| translate}}" class="p-button-success m-2"
                        (click)="retake()"></button>
                </div>
            </div>
        </p-dialog>
    </div>
    <button pButton pRipple type="button" label="{{'SUBMIT'| translate}}" class="p-button-success m-2" style="float: right;"
        (click)="submitSurveyDetails()"></button>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<!-- <p-confirmDialog 
    key="positionDialog" 
    position="center" 
    rejectButtonStyleClass="p-button-outlined"></p-confirmDialog> -->
